import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.js';  // ✅ Add .js extension
import reportWebVitals from './reportWebVitals.js';  // ✅ Add .js extension

const rootElement = document.getElementById('root');

// react-snap prerenders each page to static HTML so search engines and social
// crawlers receive the real content + correct per-page <title>/canonical in the
// raw response (that is the whole SEO win, and it is preserved regardless of
// what happens below).
//
// We deliberately do a fresh client render (createRoot) rather than hydrateRoot.
// This app renders differently at prerender-time than in a real browser — the
// responsive mobile/desktop switch (window.innerWidth) and the quizzes' random
// shuffling produce different markup — which makes strict hydration throw
// mismatch errors. A clean client render over the prerendered HTML sidesteps
// all of that with no visible downside and without touching any game logic.
ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Start measuring performance
reportWebVitals();
